import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { GrandCompteService } from '@core/services/grand-compte.service';

export const agencyGuard: CanActivateFn = () => {
    const grandCompteService = inject(GrandCompteService);
    const router = inject(Router);

    const gc = grandCompteService.currentGrandCompte();
    const isAgencyUser = !!(gc?.is_agency && !gc.isUserGcAdmin && !gc.isUserGcSuperAdmin);

    if (isAgencyUser) {
        router.navigate(['/campaigns']);
        return false;
    }

    return true;
};
